import get from 'lodash/get';
import { getNumberFormatter } from '../../../utilities/getNumberFormatter';
import { isNonEmptyString } from '../../../utilities/isNonEmptyString';

const currencyFormatter = getNumberFormatter();

export const getters = {
  currentPayment:
    state => get(state, 'responseBody.payload.mailerCode.currentPayment', null),
  currentPaymentAsCurrencyString:
    (state, { currentPayment }) => currencyFormatter(currentPayment),
  hasMailCode: state => isNonEmptyString(state.mailCode),
  hasRequestFinished: state => state.hasRequestFinished,
  isMailCodeValid: state => state.responseStatusCode === 200,
  mailCode: state => state.mailCode,
  newPayment:
    state => get(state, 'responseBody.payload.mailerCode.newPayment', null),
  newPaymentAsCurrencyString:
    (state, { newPayment }) => currencyFormatter(newPayment),
  potentialSavings:
    state => get(state, 'responseBody.payload.mailerCode.potentialSavings', null),
  potentialSavingsAsCurrencyString:
    (state, { potentialSavings }) => currencyFormatter(potentialSavings),
  preApprovalAmount:
    state => get(state, 'responseBody.payload.mailerCode.preApprovalAmount', null),
  preApprovalAmountAsCurrencyString:
    (state, { preApprovalAmount }) => currencyFormatter(preApprovalAmount)
};
